import { SidebarMenuItem } from "../../Types/Layout.type";

export const menuList: SidebarMenuItem[] = [
    {
        title: "General",
        lanClass: "lan-1",
        items: [
            {
                title: "Dashboard",
                id: 0,
                icon: "Home",
                type: "link",
                path: `${process.env.PUBLIC_URL}/dashboard`,
                active: false,
                permission: 'dashboard.view'
            },
            {
                title: "Driver",
                id: 2,
                icon: "Profile",
                type: "link",
                path: `${process.env.PUBLIC_URL}/driver`,
                active: false,
                permission: 'driver.view'
            },
            {
                title: "Vehicle",
                id: 3,
                icon: "Discovery",
                type: "link",
                path: `${process.env.PUBLIC_URL}/vehicle`,
                active: false,
                permission: 'vehicle.view'
            },
        ]
    },
    {
        title: "Operations",
        lanClass: "lan-1",
        items: [

            {
                title: "Maintenance",
                id: 4,
                icon: "Setting",
                type: "link",
                path: `${process.env.PUBLIC_URL}/maintenance`,
                active: false,
                permission: 'maintenance.view'
            },
            {
                title: "Renewal",
                id: 5,
                icon: "Paper",
                type: "sub",
                active: false,
                children: [
                    { path: `${process.env.PUBLIC_URL}/license_renewal`, title: "License Renewal", type: "link", permission: 'license-renewal.view' },
                    { path: `${process.env.PUBLIC_URL}/rc_renewal`, title: "RC Renewal", type: "link", permission: 'rc-renewal.view' },
                    { path: `${process.env.PUBLIC_URL}/permit_renewal`, title: "Permit Renewal", type: "link", permission: 'permit-renewal.view' },
                    { path: `${process.env.PUBLIC_URL}/insurance_renewal`, title: "Insurance Renewal", type: "link", permission: 'insurance-renewal.view' },
                ]
            },
            {
                title: "LPO Management",
                id: 7,
                icon: "Bag",
                type: "link",
                path: `${process.env.PUBLIC_URL}/lpo`,
                active: false,
                permission: 'lpo.view'
            },
            {
                title: "Fuel Expense",
                id: 15,
                icon: "Activity",
                type: "link",
                path: `${process.env.PUBLIC_URL}/fuel_expense`,
                active: false,
                permission: 'fuel-expense.view'
            },
            {
                title: "Accidents",
                id: 11,
                icon: "Danger",
                type: "link",
                path: `${process.env.PUBLIC_URL}/accident`,
                active: false,
                permission: 'accident.view'
            },
            {
                title: "Vehicle Sales",
                id: 12,
                icon: "Wallet",
                type: "link",
                path: `${process.env.PUBLIC_URL}/sold_vehicle`,
                active: false,
                permission: 'vehicle-sales.view'
            },
            {
                title: "Upcoming Renewal",
                id: 6,
                icon: "Calendar",
                type: "sub",
                active: false,
                children: [
                    { path: `${process.env.PUBLIC_URL}/upcoming-renewal/license`, title: "License Renewal", type: "link", permission: 'upcoming-license-renewal.view' },
                    { path: `${process.env.PUBLIC_URL}/upcoming-renewal/rc`, title: "RC Renewal", type: "link", permission: 'upcoming-rc-renewal.view' },
                    { path: `${process.env.PUBLIC_URL}/upcoming-renewal/permit`, title: "Permit Renewal", type: "link", permission: 'upcoming-permit-renewal.view' },
                    { path: `${process.env.PUBLIC_URL}/upcoming-renewal/insurance`, title: "Insurance Renewal", type: "link", permission: 'upcoming-insurance-renewal.view' },
                    { path: `${process.env.PUBLIC_URL}/upcoming-renewal/maintenance`, title: "Maintenance", type: "link", permission: 'upcoming-maintenance.view' },
                ]
            },
        ]
    },
    {
        title: "Reports",
        lanClass: "lan-1",
        items: [
            {
                title: "Vehicle Report",
                id: 10,
                icon: "Filter",
                type: "link",
                path: `${process.env.PUBLIC_URL}/vehicle_report`,
                active: false,
                permission: 'vehicle-report.view'
            },
            {
                title: "Branch Report",
                id: 13,
                icon: "Home",
                type: "link",
                path: `${process.env.PUBLIC_URL}/branch_report`,
                active: false,
                permission: 'branch-report.view'
            },
            {
                title: "Expense Report",
                id: 11,
                icon: "Chart",
                type: "link",
                path: `${process.env.PUBLIC_URL}/expense_report`,
                active: false,
                permission: 'expense-report.view'
            },
            {
                title: "Upcoming Renewal Report",
                id: 12,
                icon: "Paper",
                type: "link",
                path: `${process.env.PUBLIC_URL}/renewal_report`,
                active: false,
                permission: 'renewal-report.view'
            },
            {
                title: "Vehicle-Driver Usage Report",
                id: 13,
                icon: "Calendar",
                type: "link",
                path: `${process.env.PUBLIC_URL}/vehicle_driver_usage_report`,
                active: false,
                permission: 'vehicle-driver-usage-report.view'
            },
            {
                title: "Maintenance Report",
                id: 14,
                icon: "Setting",
                type: "link",
                path: `${process.env.PUBLIC_URL}/maintenance_report`,
                active: false,
                permission: 'maintenance-report.view'
            },
            {
                title: "LPO Report",
                id: 15,
                icon: "Bag",
                type: "link",
                path: `${process.env.PUBLIC_URL}/lpo_report`,
                active: false,
                permission: 'lpo-report.view'
            },
            {
                title: "Permit Report",
                id: 16,
                icon: "Paper",
                type: "link",
                path: `${process.env.PUBLIC_URL}/permit_report`,
                active: false,
                permission: 'permit-report.view'
            },
            {
                title: "Insurance Report",
                id: 17,
                icon: "Shield",
                type: "link",
                path: `${process.env.PUBLIC_URL}/insurance_report`,
                active: false,
                permission: 'insurance-report.view'
            },
            {
                title: "RC Report",
                id: 19,
                icon: "Paper",
                type: "link",
                path: `${process.env.PUBLIC_URL}/rc_report`,
                active: false,
                permission: 'rc-report.view'
            },
            {
                title: "License Report",
                id: 18,
                icon: "Profile",
                type: "link",
                path: `${process.env.PUBLIC_URL}/license_report`,
                active: false,
                permission: 'license-report.view'
            }
        ]
    },
    {
        title: "Master Settings",
        lanClass: "lan-1",
        items: [
            {
                title: "Branch",
                id: 1,
                icon: "Home",
                type: "link",
                path: `${process.env.PUBLIC_URL}/branch`,
                active: false,
                permission: 'branch.view'
            },
            {
                title: "Master Entry",
                id: 101,
                icon: "Discovery",
                type: "sub",
                active: false,
                children: [
                    { path: `${process.env.PUBLIC_URL}/master/service-type`, title: "Service Type", type: "link", permission: 'service-type.view' },
                    { path: `${process.env.PUBLIC_URL}/master/permit-type`, title: "Permit Type", type: "link", permission: 'permit-type.view' },
                    { path: `${process.env.PUBLIC_URL}/master/permit-authority`, title: "Permit Authority", type: "link", permission: 'permit-authority.view' },
                    { path: `${process.env.PUBLIC_URL}/master/lpo-type`, title: "LPO Type", type: "link", permission: 'lpo-type.view' },
                    { path: `${process.env.PUBLIC_URL}/master/inspection-type`, title: "Inspection Type", type: "link", permission: 'inspection-type.view' },
                ]
            },
            {
                title: "Role and Permission",
                id: 99,
                icon: "Shield",
                type: "link",
                path: `${process.env.PUBLIC_URL}/role`,
                active: false,
                permission: 'role-management.view'
            },
            {
                title: "Employee Management",
                id: 100,
                icon: "Profile",
                type: "link",
                path: `${process.env.PUBLIC_URL}/employee`,
                active: false,
                permission: 'user-management.view'
            },
            {
                title: "General Settings",
                id: 102,
                icon: "Setting",
                type: "link",
                path: `${process.env.PUBLIC_URL}/general-settings`,
                active: false,
                permission: 'general-settings.view',
            },
        ]
    },
];